export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1, viewport-fit=cover"},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#FFF"}],"link":[{"rel":"preconnect","href":"https://use.typekit.net/","crossorigin":""},{"rel":"preconnect","href":"https://cdn.dev.healthlabs.dev/","crossorigin":""},{"rel":"preconnect","href":"https://cdn.healthlabs.care/","crossorigin":""},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon/016.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon/032.png"},{"rel":"icon","type":"image/png","sizes":"128x128","href":"/favicon/128.png"},{"rel":"icon","type":"image/png","sizes":"152x152","href":"/favicon/152.png"},{"rel":"icon","type":"image/png","sizes":"180x180","href":"/favicon/180.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/favicon/192.png"},{"rel":"icon","type":"image/png","sizes":"196x196","href":"/favicon/196.png"}],"style":[],"script":[],"noscript":[],"title":"Health Labs Care"}

export const appLayoutTransition = {"name":"fade","mode":"out-in"}

export const appPageTransition = {"name":"fade","mode":"out-in"}

export const appCdnURL = ""

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const devPagesDir = null

export const devRootDir = null